'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, toast } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          success:
            'group-[.toaster]:!border-emerald-500/30 [&_[data-icon]>svg]:!text-emerald-500',
          error:
            'group-[.toaster]:!border-red-500/30 [&_[data-icon]>svg]:!text-red-500',
          warning:
            'group-[.toaster]:!border-amber-500/30 [&_[data-icon]>svg]:!text-amber-500',
          info:
            'group-[.toaster]:!border-blue-500/30 [&_[data-icon]>svg]:!text-blue-500',
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
